import React, { Component } from "react";
import ReactDOM from "react-dom";


class Portal extends Component {
  componentWillUnmount() {
    document.body.removeChild(this.defaultNode);
  }
  render()
  {
    if(!this.defaultNode) {
      this.defaultNode = document.createElement('div');
      this.defaultNode.className='evaBlocksEditor mas2';

      const shadowDom=document.getElementById("rootShadowDom");
      if(shadowDom) {
        shadowDom.appendChild(this.defaultNode);
      } else {
        document.body.appendChild(this.defaultNode);
      }
    }
    return ReactDOM.createPortal(this.props.children,this.defaultNode)
  }
}
export default Portal;
